import React, { useEffect, useState } from "react";
import axios from "axios";
import NavbarComponent from "../layout/NavbarComponent";
import { Table, Pagination, Spinner } from "react-bootstrap";
import Footer from "../layout/Footer";
import { Layout } from "../layout/Layout";
import PaginationComponent from "./PaginationComponent";

const API_URL = process.env.REACT_APP_API_URL;

const ContactMessage = () => {
    const [messages, setMessages] = useState([]);
    const [page, setPage] = useState(0);
    const [size, setSize] = useState(10);
    const [totalPages, setTotalPages] = useState(0);
    const [loading, setLoading] = useState(true);

    // Fetch messages
    const getMessages = async () => {
        setLoading(true);
        try {
            const response = await axios.get(
                `${API_URL}/getContactMessages?page=${page}&size=${size}`
            );

            setMessages(response.data.content);
            setTotalPages(response.data.totalPages);
        } catch (error) {
            console.error("Error fetching contact messages:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getMessages();
    }, [page, size]);

    return (
       <Layout>
    <div className="messages-page">

        {loading ? (
            <div className="messages-loading">
                <Spinner animation="border" style={{ color: "#e07b39" }} />
            </div>
        ) : (
            <div className="messages-container">

                {/* Heading */}
                <div className="messages-heading-row">
                    <div>
                        <h2 className="messages-title">Contact Messages</h2>
                        <p className="messages-subtitle">
                            {messages.length} {messages.length === 1 ? "message" : "messages"} on this page
                        </p>
                    </div>
                </div>

                {messages.length === 0 ? (
                    <div className="messages-empty">
                        <div className="messages-empty-badge">0</div>
                        <p className="messages-empty-text">No messages found</p>
                        <p className="messages-empty-sub">Messages sent through the contact form will show up here.</p>
                    </div>
                ) : (
                    <>
                        {/* Table Card */}
                        <div className="messages-card">
                            <div className="table-responsive">
                                <Table className="messages-table mb-0 align-middle">
                                    <thead>
                                        <tr>
                                            <th>#</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th className="d-none d-md-table-cell">Subject</th>
                                            <th className="d-none d-lg-table-cell">Message</th>
                                            <th>Message At</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {messages.map((msg, index) => (
                                            <tr key={msg.id}>
                                                <td className="messages-id">
                                                    {index + 1 + page * size}
                                                </td>
                                                <td className="fw-semibold">{msg.name}</td>
                                                <td className="text-break text-muted">{msg.email}</td>
                                                <td className="d-none d-md-table-cell">
                                                    {msg.subject}
                                                </td>
                                                <td
                                                    className="d-none d-lg-table-cell text-truncate text-muted"
                                                    style={{ maxWidth: "250px" }}
                                                >
                                                    {msg.message}
                                                </td>
                                                <td className="text-muted">
                                                    {msg.createdAt?.replace("T", " ").slice(0, 19)}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </div>

                        {/* Pagination Section */}
                        <div className="messages-pagination">
                            <PaginationComponent
                                page={page}
                                setPage={setPage}
                                size={size}
                                setSize={setSize}
                                totalPages={totalPages}
                            />
                        </div>
                    </>
                )}
            </div>
        )}

    </div>

    <style>{`
        .messages-page {
            min-height: 100vh;
            background: #F7F8F6;
            display: flex;
            flex-direction: column;
            font-family: 'Inter', sans-serif;
        }

        .messages-loading {
            display: flex;
            justify-content: center;
            align-items: center;
            flex: 1;
        }

        .messages-container {
            max-width: 1180px;
            width: 100%;
            margin: 0 auto;
            padding: 32px 24px;
            flex: 1;
        }

        .messages-heading-row {
            display: flex;
            justify-content: space-between;
            align-items: flex-end;
            margin-bottom: 22px;
        }

        .messages-title {
            font-weight: 700;
            font-size: 24px;
            color: #1C2420;
            margin: 0;
        }

        .messages-subtitle {
            font-size: 13.5px;
            color: #8B978F;
            margin: 4px 0 0;
        }

        .messages-empty {
            text-align: center;
            padding: 72px 20px;
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
        }

        .messages-empty-badge {
            width: 44px;
            height: 44px;
            border-radius: 50%;
            background: rgba(224, 123, 57, 0.1);
            color: #e07b39;
            font-weight: 700;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto 16px;
        }

        .messages-empty-text {
            font-weight: 600;
            font-size: 17px;
            color: #1C2420;
            margin: 0 0 4px;
        }

        .messages-empty-sub {
            font-size: 13.5px;
            color: #8B978F;
            margin: 0;
        }

        .messages-card {
            background: #fff;
            border-radius: 16px;
            border: 1px solid #EDEFEA;
            box-shadow: 0 1px 2px rgba(16, 24, 20, 0.03);
            overflow: hidden;
        }

        .messages-table thead {
            background: rgba(224, 123, 57, 0.06);
        }

        .messages-table thead th {
            font-size: 11.5px;
            text-transform: uppercase;
            letter-spacing: 0.06em;
            font-weight: 700;
            color: #B8632C;
            padding: 14px 16px;
            border-bottom: 1px solid #F0E4D8;
            white-space: nowrap;
        }

        .messages-table tbody td {
            padding: 14px 16px;
            font-size: 14px;
            color: #333B36;
            border-bottom: 1px solid #F2F3F0;
            vertical-align: middle;
        }

        .messages-table tbody tr:last-child td {
            border-bottom: none;
        }

        .messages-table tbody tr:hover {
            background: #FBFAF8;
        }

        .messages-id {
            font-weight: 600;
            color: #5C6862;
        }

        .messages-pagination {
            margin-top: 20px;
            display: flex;
            justify-content: flex-end;
        }
    `}</style>
</Layout>

    );
};

export default ContactMessage;
